
export const SECTION_GROUP_HELP = {
  WS_PV_PLACEVALUE1: {
    type: "image",
    source: "/images/expanded-form.png",
    keyPoints: [
      "Split the number by place value",
      "Thousands, hundreds, tens, ones",
      "Add the parts together"
    ]
  },
  WS_PV_PLACEVALUE: {
    type: "video",
    source: "https://www.youtube.com/embed/xxxxx",
    keyPoints: [
      "Compare digits from left",
      "The first bigger digit decides"
    ]
  },
  WS_BIDMAS: {
    type: "video",
    source: "https://www.youtube.com/embed/xxxxx",
    keyPoints: [
      "Compare digits from left",
      "The first bigger digit decides"
    ]
  },
  WS_POWERS_EQUAT: {
    type: "video",
    source: "https://www.youtube.com/embed/xxxxx",
    keyPoints: [
      "Compare digits from left",
      "The first bigger digit decides"
    ]
  },
  WS_PV_COMPARE_ORDER: {
    type: "video",
    source: "https://www.youtube.com/embed/xxxxx",
    keyPoints: [
      "Compare digits from left",
      "The first bigger digit decides"
    ]
  },
  WS_POWERS_10: {
    type: "video",
    source: "https://www.youtube.com/embed/xxxxx",
    keyPoints: [
      "Compare digits from left",
      "The first bigger digit decides"
    ]
  }
};
